<template>
    <div id="app">
        <!--<header-default/>-->
        <main class="main-wrapper wp">
            <router-view/>
        </main>
        <footer class="footer">
            © 2017-2019 阿特拉斯·科普柯公司版权所有
        </footer>
    </div>
</template>
<script>
    import HeaderDefault from './components/header-default'

    export default {
        name: "APP",
        components: {
            HeaderDefault,
        }
    }
</script>


<style lang="scss">
    @import "./style/color.scss";

    .right-table {
        flex: 1;

        .table {
            width: 100%;
            border: 1px solid #dbdada;
            border-collapse: collapse;
            border-spacing: 0;

            th {
                padding-left: 20px;
                height: 45px;
                border: 1px solid #eaeaea;
                background-color: #f7f8fb;

                &:last-of-type {
                    text-align: right;
                    padding-left: 0;
                    padding-right: 20px;
                }

                @media (max-width: 900px) {
                    text-align: center;
                    padding-left: 0;
                    font-size: 12px;
                    height: 35px;
                    &:last-of-type {
                        text-align: center;
                        padding-right: 0;
                    }
                }
            }

            td {
                @extend th;
                background-color: #fff;

                &.bold {
                    font-weight: 700;
                }

                &:last-of-type {
                    color: #fe6305;

                    span {
                        position: relative;

                        &:after {
                            font-family: "iconfont";
                            content: "\e623";
                        }
                    }

                    &.top {
                        color: $main-color;

                        span {
                            &:after {
                                content: "\e622";
                            }
                        }
                    }
                }
            }

            tr {
                &:nth-child(2n) {
                    td {
                        background-color: #f7f8fb;
                    }
                }
            }
        }

        .bottom-list {
            height: 55px;
            border: 1px solid #dbdada;
            border-top: none;
            border-right: none;
            display: flex;

            li {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #dbdada;
                background-color: $main-color;
                color: #fff;
                font-weight: 700;

                &.yellow {
                    background-color: #ffc200;
                }

                @media (max-width: 900px) {
                    font-size: 12px;
                    padding: 0 5px;
                }
            }
        }
    }

    .main-wrapper {
        font-size: 14px;
        background-color: #fff;
        box-shadow: 0px 0px 10px #ccc;

        &.wp {
            margin-top: 15px;
            @media (max-width: 900px) {
                margin-top: 5px;
                margin-bottom: 0;
            }
        }

        .none-echart {
            position: fixed;
            top: 999999px;
            left: 0;
            width: 100%;
            height: 400px;
        }

        .wrapper-padding {
            padding: 15px 10px 0 10px;
        }

        .print-wrapper-fixed {
            display: none;
        }

        .main-body {
            display: flex;

            .left-chart {
                width: 400px;
                flex: 0 0 400px;
                background: #f7f8fb;
                margin-right: 10px;
            }


            @media (max-width: 900px) {
                flex-wrap: wrap;
                font-size: 14px;
                .left-chart {
                    width: 100%;
                    flex: 0 0 100%;
                    height: 280px;
                    margin-right: 0;
                    margin-bottom: 10px;
                }
                .right-table {
                    width: 100%;
                    flex: 0 0 100%;
                }
                .bottom-list {
                    li {
                        text-align: center;
                    }
                }
            }

        }

        .operate-wrapper {
            margin: 10px 0;
            background-color: #f7f8fb;
            display: flex;
            align-items: center;
            padding: 30px 20px;

            input[type="range"] {
                width: 100%;
                height: 5px;
                border: 0;
                background-color: #d9dadb;
                position: relative;
                -webkit-appearance: none !important;
                outline: none;
            }

            input[type=range]::-webkit-slider-thumb {
                -webkit-appearance: none;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: #fff;
                border: 5px solid #fff;
                cursor: pointer;
            }

            .range {
                flex: 1;
                padding: 0 30px;
            }

            .inp {
                input {
                    height: 30px;
                    max-width: 120px;
                    width: 100%;
                    text-align: right;
                    padding: 0 10px;
                    border: 1px solid #999;
                    outline: none;
                    box-shadow: none;

                    &:focus {
                        border-color: $main-color;
                    }

                    @media (max-width: 900px) {
                        width: 80px;
                    }
                }
            }

            @media (max-width: 650px) {
                flex-wrap: wrap;
                .label {
                    width: 100%;
                    flex: 0 0 100%;
                }
                .range {
                    padding-left: 0;
                }
            }

        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        input[type="number"] {
            -moz-appearance: textfield;
        }

        .select-wrapper {
            height: 100px;
            display: flex;

            li {
                cursor: pointer;
                flex: 1;
                text-align: center;
                color: #696969;
                padding-top: 10px;

                i {
                    font-size: 35px;
                }

                &.active {
                    background-color: $main-color;
                    color: #fff;
                }
            }

            @media (max-width: 900px) {
                flex-wrap: wrap;
                height: auto;
                li {
                    padding: 10px;
                    white-space: nowrap;
                }
            }
            /*横屏*/
            @media screen and (orientation: landscape) {
            }
            /* 竖屏 */
            @media screen and (orientation: portrait) {
                li {
                    div {
                        display: none;
                    }
                }
            }
        }

        .set-wrapper {
            padding-bottom: 30px;
            width: 100%;
            overflow: hidden;

            .section-title {
                background-color: #f7f8fb;
                height: 45px;
                display: flex;
                align-items: center;
                padding-left: 15px;
                font-weight: 700;
                margin-bottom: 10px;

                &.mb {
                    margin-top: 10px;
                }

                @media (max-width: 751px) {
                    margin: 0 -15px;
                }
            }

            .form-item {
                display: flex;
                align-items: center;
                padding: 10px 0;

                .label {
                    padding-left: 15px;
                    flex: 0 0 300px;
                }

                input {
                    height: 30px;
                    padding: 0 10px;
                    width: 300px;
                    border: 1px solid #bfbfbf;
                    background-color: #f7f8fb;
                    outline: none;

                    &:focus {
                        border-color: $main-color;
                    }
                }

                @media (max-width: 751px) {
                    flex-wrap: wrap;
                    .label {
                        flex: 0 0 100%;
                        margin-bottom: 10px;
                        font-size: 12px;
                        font-weight: 700;
                        padding-left: 0;
                    }
                    .content-wrap {
                        padding-left: 0;
                        width: 100%;

                        input {
                            width: 100%;
                        }
                    }
                }
            }

            .btns {
                padding-top: 20px;
                padding-left: 15px;
                @media (max-width: 751px) {
                    text-align: center;
                }

                button {
                    padding: 8px 35px;
                    border: none;
                    box-shadow: none;
                    outline: none;
                    background: $main-color;
                    color: #fff;
                    cursor: pointer;
                    margin-right: 15px;

                    &.cancel {
                        background-color: #c5c3c3;
                    }

                    &:active {
                        opacity: .8;
                    }
                }
            }


        }
    }

    .footer{
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #333;
    }
</style>
